import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import i18n, { initLocale, getCurrentLocale } from './i18n'
import { setLocale } from './api/axios'

initLocale()
setLocale(getCurrentLocale())

createApp(App).use(router).use(i18n).mount('#app')
